module.exports = __webpack_public_path__ + "img/ecommerce-product-img-1.89a51bf8.png";